import { render, staticRenderFns } from "./PostedMeta.vue?vue&type=template&id=216842c9"
import script from "./PostedMeta.vue?vue&type=script&lang=js"
export * from "./PostedMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports